import {ADMIN_VERSION_API} from "@/contants/api";
const revenueReportsRoute = `${ADMIN_VERSION_API}/revenue-reports`;

export default $axios => ({
  index() {
    return $axios.get(revenueReportsRoute);
  }
});
